import React from 'react';
import './index.css';



function CV() {
  return (

    <div id="cv">

      <h2>Statement</h2>

        <p>
        i employ visual metaphors to distill complexity into simple forms, incorporating various mediums including sculpture, live performance, painting, video and sound. i am intrigued by how the self-imposed restraint to limit information can both guide the creative process and public discourse. while metaphor is essential in my conception and process, my focus is not primarily on the ideological but on the sensory, aesthetic experience at a primal, physical level. studio art practice keeps me grounded through the use of formal qualities such as light and shadow, scale and composition. my inspirations come from experimenting with various materials that surround me in daily routine. this practice is the backbone of my theatrical presentation. much of my performance work employs methodical repetition. i commit myself and my performers to submit to task-based action, to attend to each step, to blow a horn or to pour out water. within a strictly defined structure, there is freedom from mundane psychological preoccupations. the more the performer removes the sense of self but just pursues the action, the more the audience responds. our contact strengthens. i am eager for this dialogue.
        </p>

</div>

  );
}

export default CV;

